import { request } from "./client";

/**
 * League owners/admins customize the wording of the notification emails their league sends.
 * Each item: { category, label, description, mergeFields: [{ name, description, example }],
 * limits, defaults, current, isCustomized } where defaults/current are
 * { subject, heading, body, buttonLabel }.
 */
export const listEmailTemplates = async (leagueId) => request(`/leagues/${leagueId}/email-templates`);

export const saveEmailTemplate = async (leagueId, category, content) =>
  request(`/leagues/${leagueId}/email-templates/${category}`, { method: "PUT", body: JSON.stringify(content) });

/** Removes the customization so the built-in default is used again. */
export const resetEmailTemplate = async (leagueId, category) =>
  request(`/leagues/${leagueId}/email-templates/${category}`, { method: "DELETE" });

/** Renders unsaved text with sample data. Returns { valid, errors, subject?, html?, text? }. */
export const previewEmailTemplate = async (leagueId, category, content) =>
  request(`/leagues/${leagueId}/email-templates/${category}/preview`, { method: "POST", body: JSON.stringify(content) });
